module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/node_modules/browserify-sign/algos.js
// module id = 1539
// module chunks = 7